export enum FileUploadContexts {
  PLANNING = 1,
  SERVICE_PROVIDER_APP = 2,
  SYSTEM = 3,
  COLUMN_INCOMING_INVOICES = 4
}
